import * as React from 'react';

import { TjmGridPanel } from '@/routes/supplier/rate-collection/tjm-grid-panel';

// =============================================================================
// saisie-screen.tsx — Écran de SAISIE FOURNISSEUR (route `/saisie`, DDD §3.6, S12 / D2).
// =============================================================================
// PHASE C (GATE_HUMAN 2026-09-12) : la grille + sa colonne latérale + TOUTE la logique de saisie ont été
// EXTRAITES dans `<TjmGridPanel/>` (composant réutilisable), embarqué ici (route dédiée, deep-link préservé)
// ET dans le détail `/campagnes`. Cet écran n'est plus qu'un ADAPTATEUR de route : il pose la <section>
// racine + le contexte d'URL (submission, famille, cycle, profil deep-linké) et délègue au panneau qui
// porte l'en-tête refondu (titre + badge NOIR + sous-ligne + « Sauvegardé … » + UNIQUE CTA ambre) et la
// grille 2 colonnes (tableau + colonne latérale sticky). AUCUNE perte de fonctionnalité (voir rapport PHASE C).

export interface SaisieScreenProps {
  readonly submissionId: string;
  /** Famille sélectionnée (état d'URL ; `undefined` = toutes). */
  readonly selectedFamily?: string | undefined;
  /** Notifie le routeur d'un changement de filtre famille (écrit l'état d'URL). */
  readonly onSelectFamily: (family: string | undefined) => void;
  /** F-10 (S17) : la campagne est en CYCLE 2 (état d'URL `cycle`). Active la lecture de l'indicateur. */
  readonly cycle2?: boolean | undefined;
  /** Numéro de cycle brut issu de l'URL (search param `cycle`) — alimente le header contextuel. */
  readonly cycleNumber?: number | undefined;
  /** R15-CMP-03 / F0-CONTRACT-4 — profil DEEP-LINKÉ depuis la fiche catalogue (search param `profil`). */
  readonly deepLinkProfile?: string | undefined;
}

export function SaisieScreen({
  submissionId,
  selectedFamily,
  onSelectFamily,
  cycle2 = false,
  cycleNumber,
  deepLinkProfile,
}: SaisieScreenProps): React.JSX.Element {
  return (
    <section aria-labelledby="saisie-title" className="p-6">
      <TjmGridPanel
        submissionId={submissionId}
        selectedFamily={selectedFamily}
        onSelectFamily={onSelectFamily}
        cycle2={cycle2}
        cycleNumber={cycleNumber}
        deepLinkProfile={deepLinkProfile}
        variant="route"
        headingId="saisie-title"
      />
    </section>
  );
}
